var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import layoutItemMigrations from './layoutItems';
/**
* Version 5 migrations for the website.
* - Replacing "widgetType: 'Section'" with "sectionType: 'Section'" in section layout items.
* - If for some reason the item is a 'sectionRow' without a sectionType, add the default "sectionType: 'Section'".
*/
export default function v4(website) {
    return __assign(__assign({}, website), { frameworkVersion: 5, layoutItems: layoutItemMigrations(website.layoutItems) });
}
